
import { Component, Prop, Vue } from "vue-property-decorator";
import { TelemetryEntryListElement } from "../telemetry.types";

@Component
export default class TelemetryConfigDatapointComponent extends Vue {
    @Prop() datapoint!: TelemetryEntryListElement;

    dpChangeEvent(action: "add" | "move" | "remove", args?: any) {
        let event = {
            action,
            args
        }

        this.$emit("dpupdate", event);
    }
}
